export default __webpack_public_path__ + "static/media/icon-ai-purple.c29608ad.svg";